// extracted by mini-css-extract-plugin
module.exports = {"borderTab":"link-tabs_borderTab__wpQzq","borderTab_tablet":"link-tabs_borderTab_tablet__Tw5sR","borderTab_mobile":"link-tabs_borderTab_mobile__oQIlv"};